import { GraphQL } from "@rpi/openapi-api";

/** The tiers currently offered — the deprecated enum values (Express, Priority) are retained for API compatibility only. */
export const CURRENT_SHIPPING_CLASSIFICATIONS: GraphQL.OpenapiProvidedShippingClassification[] = [
  GraphQL.OpenapiProvidedShippingClassification.Economy,
  GraphQL.OpenapiProvidedShippingClassification.Standard,
  GraphQL.OpenapiProvidedShippingClassification.Expedited,
  GraphQL.OpenapiProvidedShippingClassification.Rush,
];
